export enum DetectionRuntimeType {
    Runtime = 'runtime',
}
